var map = {
	"./arrowRight.svg": "/mtx",
	"./arrowRight1.svg": "nS7+",
	"./arrowRight2.svg": "w0l2",
	"./close.svg": "toIl",
	"./line.svg": "9xjd",
	"./line1.svg": "UQy8",
	"./list.svg": "vuHp",
	"./list1.svg": "sCml",
	"./logo.svg": "ZY77",
	"./sellBg.svg": "bju/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 21